import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestNavMenuAddLinksPost = {
    path: "/nav-menu/add-links",
    method: RouteHttpVerb.POST
};
